import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'CurrentRaportSm.category',
    defaultMessage: 'Kategoria:'
  }
});



// WEBPACK FOOTER //
// ./src/views/CurrentReports/CurrentReportsSm.intl.js